import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import { gEnums } from '../../enums/globalEnums';
import { currentHelpers } from '../../redirection/current';
import { createRefPath, createRefPath_client } from '../appData/appRefPaths';

/**
 * Updates the `profiles` collection (viewKey) with the `name` and `path` of the selected item.
 * @param {function} dispatch 
 * @param {object} appUser 
 * @param {object} paps_state 
 * @param {string} pageDataCaption 
 */
export const updateProfilePageFavorite = (dispatch, database_fns, fn_cls, appUser, appUsers, paps_state, platform, pageDataCaption, favItem) => {

  const { name: platform_name } = platform ?? {}
  const { profileData, uid } = appUser ?? {}
  const { fcmTokens } = profileData ?? {}
  const fcmToken = fcmTokens ? fcmTokens[platform_name] : {}
  const { tokenKey: appUserToken } = fcmToken ?? {}

  const { pathViews, view, viewKey, pathName } = paps_state ?? {}
  const { key: key_fav, name: name_fav, pathName: pathName_fav } = favItem ? favItem : {}
  const favCollectionKey = key_fav ? favItem[key_fav] : null

  const _view = key_fav ? key_fav : view
  const _viewKey = favCollectionKey ? favCollectionKey : viewKey
  const _pageDataCaption = name_fav ? name_fav : pageDataCaption
  const _pathName = pathName_fav ? pathName_fav : pathName

  const appUserAccess = useAppUserAccess()

  const { appUserAccessType, email, favs_info } = appUserAccess ?? {}
  let { pageFavs } = favs_info ?? {}

  const { districts, sports } = pathViews ?? {}

  if (!pageFavs) { pageFavs = {} }
  if (!pageFavs[_view]) { pageFavs[_view] = {} }

  let _favKey;
  let unsubscribe;

  if (pageFavs[_view][_viewKey]) {
    delete pageFavs[_view][_viewKey]
    _favKey = _viewKey
    unsubscribe = true
  } else {
    pageFavs[_view][_viewKey] = {
      name: _pageDataCaption,
      pathName: _pathName
    }
    if (districts) { pageFavs[_view][_viewKey].districts = districts }
    if (sports) { pageFavs[_view][_viewKey].sports = sports }
    _favKey = _viewKey
    unsubscribe = false
  }

  const d = {
    pageFavs
  }

  let _refPath;

  const cb = async (res) => {
    if (appUserToken) {
      const rest = await fn_cls.subscribeToTopic(appUserToken, _favKey, unsubscribe, uid)
    }
    dispatch(res)
  }

  if (appUserAccessType && profileData?.id) {
    switch (appUserAccessType) {
      case gEnums.appUserAccessTypes.admin:
      case gEnums.appUserAccessTypes.superAdmin:
        _refPath = createRefPath(['profiles', profileData.id])
        break;
      default:
        _refPath = createRefPath_client(pathViews, ['profiles', email])
    }
    database_fns.update_docc({
      refPath: _refPath,
      data: d,
      callback: cb
    })
  } else {
    currentHelpers.storageItem_set('pageFavs', JSON.stringify(pageFavs))
  }
} 